import {React, useEffect, useState} from 'react'
import axios from  '../api/axios';

export default function AllCategory() {
  const [categories, setCategories] = useState([]);

  useEffect(() => {
    const fetchCategories = async () => {
      try {
        const response = await axios.get('/categories');
        setCategories(response.data);
      } catch (error) {
        console.error('Error fetching categories:', error);
      }
    };

    fetchCategories();
  }, []);

  return (
    <div>
      <h2 className="mb-4">All Categories</h2>
      <ul className="list-disc pl-5">
        {categories.map((category) => (
          <li key={category.id} className="text-gray-700">
            {category.name}
          </li>
        ))}
      </ul>
    </div>
  )
}
